import React from 'react';

/**
 * CheckboxElement - Independent checkbox component
 * Fully self-contained with no external layout dependencies
 */
const CheckboxElement = ({ element, mode = 'form' }) => {
  const { content } = element;
  const {
    label = '',
    name = '',
    text = 'I agree',
    required = false,
    helpText = ''
  } = content || {};

  // Generate field name from text if not provided
  const fieldName = name || text.toLowerCase().replace(/[^a-z0-9]+/g, '_');

  return (
    <div className="form-field" style={{ width: '100%', boxSizing: 'border-box' }}>
      {label && <div className="form-label" style={{ marginBottom: '0.5rem' }}>{label}</div>}
      <label className="form-checkbox-label" htmlFor={fieldName}>
        <input
          type="checkbox"
          id={fieldName}
          name={fieldName}
          className="form-checkbox"
          required={required}
          aria-required={required}
          aria-describedby={helpText ? `${fieldName}-help` : undefined}
        />
        <span className="form-checkbox-text">{text}</span>
      </label>
      {helpText && (
        <p
          id={`${fieldName}-help`}
          className="form-help-text"
          style={{ fontSize: '0.875rem', color: 'var(--color-text-secondary)', marginTop: '0.25rem' }}
        >
          {helpText}
        </p>
      )}
    </div>
  );
};

export default CheckboxElement;
